<div class="page-container explorer-container container w-100">
  <app-utility-toolbar
    [current]="'repBehavior'"
    [vertical]="true"
    class="{{ navCollapsed ? 'w-5' : 'w-15' }} vertical"
    (toggleCollapse)="toggleNavCollapse()"
    [links]="dashboardLinks"
  ></app-utility-toolbar>
  <div
    class="explorer-content-container ps-3"
    [ngClass]="{ collapsed: navCollapsed }"
  >
    <app-rb-grid
      #repBehaviorGrid
      [gridConfig]="gridConfig"
      [getSetup]="getGridSetup"
      [getData]="getRepBehavior"
    >
      <button
        mat-button
        color="primary"
        class="grid-button header-button"
        (click)="dlXlsx()"
        [disabled]="fileLoading || repBehaviorGrid.disableSearch(true)"
      >
        <span class="button-label-with-icon">
          @if (fileLoading) {
            <mat-spinner diameter="20"></mat-spinner>
          } @else {
            <mat-icon>cloud_download</mat-icon>
          }
          Download Excel File
        </span>
      </button>
    </app-rb-grid>
  </div>
</div>
